var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"alert-msg",class:_vm.colorAlert,attrs:{"dismissible":"","show":_vm.getTime}},[_vm._v(" "+_vm._s(_vm.getText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }